import React from 'react'

const CompteDesactiver = () => {
  return (
    <div className='flex flex-1 justify-center items-start'>CompteDesactiver</div>
  )
}

export default CompteDesactiver